import { render } from "./ContactUsView.vue?vue&type=template&id=5444f72d&ts=true"
import script from "./ContactUsView.vue?vue&type=script&lang=ts"
export * from "./ContactUsView.vue?vue&type=script&lang=ts"

import "./ContactUsView.vue?vue&type=style&index=0&id=5444f72d&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__